

import { PostApi, GetApi } from '../js_assets/Network'

export function CreateSubscriptionSchedule(Subscription_Schedule_Model) {

    return new Promise(function (resolve) {

        PostApi(`/api/trainer/Save_Subscription_Schedule/30`, Subscription_Schedule_Model, null).then(() => {



            GetApi(`/api/chat/GetConversionID/${Subscription_Schedule_Model.trainer_Id}/${Subscription_Schedule_Model.UserID}`, null)
                .then(() => {

                    resolve(true);
                })



        })
    });

}


export function FetchPaymentUser(payment_model, jwt_Token_User) {

    return new Promise(function (resolve) {

        PostApi('/api/User/Fetch_Payment_User_Once', payment_model, jwt_Token_User)
            .then((result) => {
                resolve(result);

            })
    });

}